export default class JSONValidationError extends Error {

}